import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// loading初始状态
const state = {
  isShow: false,
  appKey: localStorage.getItem('appKey')
}

// 创建 store 实例
export default new Vuex.Store({
  state
})



// WEBPACK FOOTER //
// ./src/vuex/store.js